import React, { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import { CiMobile2 } from "react-icons/ci";
import logo from "../../fifthAssets/Images/logo.jpeg";
import { VscThreeBars } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { useHistory, useLocation } from "react-router-dom";
import allPaths from '../../Config/paths';
import { useDispatch } from 'react-redux';
import { setLanguage } from "../../Redux/actions/languageAction";
import ReactFlagsSelect from 'react-flags-select';
import EnglishFlag from '../../assets/Images/englishFlag.png';
import GermanLanguage from '../../assets/Images/germanLangugae.png';
import ArabicLanguage from '../../assets/Images/arabicLanguage.jpg';
import { menuItems } from "../../fifthUtils/constant";
import { IoCall, IoMail, IoLocation } from "react-icons/io5";
import ukFlag from "../../fifthAssets/Images/uk-flag.jpg";
import germanFlag from "../../fifthAssets/Images/german-flag.webp";
import egyptFlag from "../../fifthAssets/Images/egypt-flag.png";
import { FaPlus, FaMinus } from "react-icons/fa6";

const Header = (props) => {
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [activeSubmenus, setActiveSubmenus] = useState({});
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english';
    const isAlSelect = language?.language === 'arabic';

    const changeLanguage = (language) => {
        dispatch(setLanguage(language));
    };

    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 40) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
            lastScrollTop = scrollTop;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggled = () => {
        setToggle(!toggle);
    };

    const handleNavigation = (path) => {
        history.push(path);
    };
    const handleMobNavigation = (path) => {
        history.push(path);
        setToggle(!toggle);
    };

    const toggleMobileSubmenu = (menuName) => {
        setActiveSubmenus(prev => ({
            ...prev,
            [menuName]: !prev[menuName]
        }));
    };

    return (
        <div className="fifth-des-header-main">
            <div className="fifth-des-header-1-main">
                <div className="fifth-des-header-1">
                    <h2>
                        {selectedLanguage?.txt_call_us_today} +2 01021055271/2 | info@amsterdamclinics.com
                    </h2>
                    <div>
                        <img onClick={() => changeLanguage('english')} src={ukFlag} alt="" />
                        <img onClick={() => changeLanguage('arabic')} src={egyptFlag} alt="" />
                        <img onClick={() => changeLanguage('german')} src={germanFlag} alt="" />
                    </div>
                </div>
            </div>
            <div className={isHeaderFixed ? "fifth-design-header-fixed" : ""}>
                <div className="fifth-des-header-2">
                    <div className="fifth-des-header-2-inner-1">
                        <div className="fifth-des-header-logo-div">
                            <img src={logo} alt="" />
                        </div>
                        <div className="fifth-des-toggle-btn-div" onClick={toggled}>
                            {!toggle ?
                                <VscThreeBars />
                                :
                                <IoMdClose />
                            }
                        </div>
                        <nav className="fifth-des-header-2-inner-2 fifth-des-web-header">
                            <div>
                                <ul className="fifth-design-nav">
                                    {menuItems?.map((item, index) => (
                                        <li key={index}
                                            className={location?.pathname === item?.menuRoute ? "fifth-des-active-nav" : ""}
                                            onMouseEnter={() => setHoveredItem(item?.menuName)}
                                            onMouseLeave={() => setHoveredItem(null)}
                                            onClick={() => handleNavigation(item?.menuRoute)}
                                        >
                                            <a href="" onClick={(e) => e.preventDefault()}>
                                                {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}
                                            </a>
                                            {hoveredItem === item?.menuName && item?.submenu ? (
                                                <div className="fifth-des-submenu">
                                                    {item?.submenu.map((sub, i) => (
                                                        <a key={i} href="" onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            handleNavigation(sub.route);
                                                        }}>
                                                            {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                        </a>
                                                    ))}
                                                </div>
                                            ) : null}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </nav>
                    </div>
                        {toggle ? (
                            <nav className="fifth-des-header-2-inner-2 fifth-des-mob-header">
                                    <ul>
                                        {menuItems.map((item, index) => (
                                            <div key={index}>
                                                <div className={location?.pathname === item?.menuRoute ? "fifth-des-active-nav fifth-des-mob-active-nav" : ""}>
                                                    <li onClick={() => handleMobNavigation(item.menuRoute)}>
                                                        <a>{isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}</a>
                                                    </li>
                                                    {item.submenu ? (
                                                        <button className="sub-menu-btn" onClick={() => toggleMobileSubmenu(item.menuName)}>
                                                            {activeSubmenus[item?.menuName] ? <FaMinus /> : <FaPlus />}
                                                        </button>
                                                    ) : null}
                                                </div>
                                                {
                                                    activeSubmenus[item?.menuName] && item?.submenu ? (
                                                        item.submenu.map((sub, i) => (
                                                            <li className="mobile-sub-menu fifth-des-mob-sub-menu" key={i}>
                                                                <a href="#" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleMobNavigation(sub?.route);
                                                                }}>
                                                                    {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : null
                                                }
                                            </div>
                                        ))}
                                    </ul>
                            </nav>
                        ) : null}
                </div>
            </div>
        </div>
    );
};

export default Header;
